module.exports = __webpack_public_path__ + "static/HSE_Q2-2021_Announcement_Fin Results_Investor Call-8f4b54cea1cb3ec631df6b83bf6276a8.pdf";